/** base url for valhalla nav endpoints to be used with final end point strings e.g. ``` ROUTE_ENDPOINT=`${evNavEndpoint}/route` ```. */
export const valhallaBaseUrl = "https://valhalla.pt.appstack.me/";
